import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import React, { useContext, useRef, useState } from "react";
import { CarCompetitionData } from "../contextProvider";
import { useIsMobile } from "@/app/redux/features/device/selectors";
import "swiper/css";
import "swiper/css/navigation";

const Gallery = () => {
  const { galleryImages, media } = useContext(CarCompetitionData);
  const images = galleryImages.length > 0 ? galleryImages : media;
  const isMobile = useIsMobile();
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  if (!images.length) return null;

  return (
    <div className="relative w-full overflow-hidden rounded-lg lg:rounded-2xl aspect-[328/184] lg:aspect-[1360/765]">
      <Swiper
        modules={[Navigation, A11y]}
        slidesPerView={1}
        spaceBetween={0}
        navigation={
          !isMobile
            ? {
                prevEl: "#xc-gallery-prev",
                nextEl: "#xc-gallery-next",
              }
            : false
        }
        onSlideChange={swiper => setActiveIndex(swiper.realIndex)}
        onSwiper={swiper => {
          swiperRef.current = swiper;
        }}
        className="size-full">
        {images.map((src, index) => (
          <SwiperSlide key={`gallery-${index}`}>
            <img
              src={src}
              alt={`Gallery image ${index + 1}`}
              className="size-full object-cover"
              width={1360}
              height={765}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {!isMobile && (
        <div className="absolute top-1/2 left-10 right-10 z-10 flex items-center justify-between -translate-y-1/2 pointer-events-none">
          <button
            id="xc-gallery-prev"
            type="button"
            aria-label="Previous gallery image"
            className="pointer-events-auto flex items-center justify-center size-11 bg-[#f0f0f0] rounded-[14px] border-0 cursor-pointer rotate-180">
            <img
              src="/assets/images/car-competition/gallery-nav-arrow.svg"
              alt=""
              className="w-[8px] h-[15px]"
              width={8}
              height={15}
            />
          </button>
          <button
            id="xc-gallery-next"
            type="button"
            aria-label="Next gallery image"
            className="pointer-events-auto flex items-center justify-center size-11 bg-[#f0f0f0] rounded-[14px] border-0 cursor-pointer disabled:opacity-35">
            <img
              src="/assets/images/car-competition/gallery-nav-arrow.svg"
              alt=""
              className="w-[8px] h-[15px]"
              width={8}
              height={15}
            />
          </button>
        </div>
      )}

      <div className="absolute bottom-3 lg:bottom-6 left-3 lg:left-10 z-10 flex items-center justify-center w-7 h-[18px] lg:w-auto lg:h-auto bg-black/50 text-white font-roboto lg:font-jost text-[10px] lg:text-base font-medium leading-3 lg:leading-5.5 px-1.5 py-0.5 rounded">
        {activeIndex + 1}/{images.length}
      </div>
    </div>
  );
};

export default Gallery;
